"use strict";
/** Hierarchical Score Rollup View shared types (TASK-4 — FR-9 → AC-9.1, AC-9.2).
 *
 * Single contract for the `GET /rollup/{parentTeamNumber}` endpoint, shared by
 * the data-api Lambda (producer) and the dashboard (consumer). Discovery mode
 * fills `topUnits` with features; Delivery mode fills them with repos.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROLLUP_VERSION = exports.ROOT_SCOPE_NAME = exports.ROOT_SCOPE_NUMBER = void 0;
/**
 * The synthetic tier-0 root scope (`__root__`, displayed as "CAPTG") — a
 * producer↔consumer contract value defined ONCE here so no side re-literals it
 * (constitution: shared cross-lambda constants; the score-cache org-case defect
 * precedent). `rollup-sweep` (producer) injects this node into its in-memory
 * SLED tree and materializes `ROLLUP#<mode>#SCOPE#__root__` via
 * `rollupKey(mode, ROOT_SCOPE_NUMBER)`; `data-api` (consumer) resolves the same
 * key from the URL path param; the dashboard's `ROOT_NUMBER` / `ROOT_NODE.name`
 * resolve to these (AC-3.2). Not a real SLED row — synthetic root only.
 */
exports.ROOT_SCOPE_NUMBER = '__root__';
exports.ROOT_SCOPE_NAME = 'CAPTG';
exports.ROLLUP_VERSION = 'v3';
//# sourceMappingURL=rollup.js.map